import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import seloJuridico from "../public/selo-juridico.png";
import SeloSystems from "../components/SeloSystems";
import { useAuth } from "../context/AuthContext";
import { Button, Card, Field, Input } from "../components/ui";

const RegistroEscritorio = () => {
    const navigate = useNavigate();
    const { registrar } = useAuth();
    const [erro, setErro] = useState(null);
    const [carregando, setCarregando] = useState(false);
    const [formData, setFormData] = useState({
        nome_escritorio: "",
        nome: "",
        email: "",
        senha: "",
        confirmarSenha: "",
        oab: "",
        uf_oab: "",
        telefone: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErro(null);

        if (formData.senha !== formData.confirmarSenha) {
            setErro("As senhas não conferem.");
            return;
        }

        setCarregando(true);
        try {
            await registrar({
                nome_escritorio: formData.nome_escritorio,
                nome: formData.nome,
                email: formData.email,
                senha: formData.senha,
                oab: formData.oab || undefined,
                uf_oab: formData.uf_oab || undefined,
                telefone: formData.telefone || undefined
            });
            navigate("/inicio", { replace: true });
        } catch (err) {
            setErro(err.response?.data?.error || "Não foi possível registrar. Verifique a conexão.");
        } finally {
            setCarregando(false);
        }
    };

    return (
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 28, padding: "32px 16px" }}>
            <Card as="form" className="elev-md" style={{ width: "100%", maxWidth: 460, gap: 16, padding: 28 }} onSubmit={handleSubmit}>
                <img src={seloJuridico} alt="" style={{ height: 110, width: "auto", margin: "0 auto" }} />
                <div>
                    <h1>
                        Crie seu <span style={{ color: "var(--color-accent)" }}>escritório</span>
                    </h1>
                    <p className="text-muted" style={{ fontSize: 14 }}>
                        Você será o proprietário e poderá criar perfis para associados e estagiários.
                    </p>
                </div>

                <Field label="Nome do escritório">
                    <Input name="nome_escritorio" required value={formData.nome_escritorio} onChange={handleChange} />
                </Field>

                <Field label="Seu nome">
                    <Input name="nome" required value={formData.nome} onChange={handleChange} />
                </Field>

                <Field label="E-mail">
                    <Input type="email" name="email" required autoComplete="email" value={formData.email} onChange={handleChange} />
                </Field>

                <div className="grid-form">
                    <Field label="Senha (mín. 6 caracteres)">
                        <Input type="password" name="senha" required minLength={6} autoComplete="new-password" value={formData.senha} onChange={handleChange} />
                    </Field>
                    <Field label="Confirmar senha">
                        <Input type="password" name="confirmarSenha" required minLength={6} autoComplete="new-password" value={formData.confirmarSenha} onChange={handleChange} />
                    </Field>
                    <Field label="OAB (6 dígitos, opcional)">
                        <Input name="oab" maxLength={6} pattern="[0-9]{6}" title="6 números (ex: 123456)" value={formData.oab} onChange={handleChange} />
                    </Field>
                    <Field label="UF da OAB">
                        <Input name="uf_oab" maxLength={2} placeholder="PB" value={formData.uf_oab} onChange={handleChange} />
                    </Field>
                    <Field label="Telefone" className="span-2">
                        <Input type="tel" name="telefone" maxLength={11} value={formData.telefone} onChange={handleChange} />
                    </Field>
                </div>

                {erro && <p className="erro">{erro}</p>}

                <Button type="submit" disabled={carregando} className="btn-block">
                    {carregando ? "Criando..." : "Criar escritório"}
                </Button>

                <p className="text-muted" style={{ fontSize: 14.5, margin: 0, textAlign: "center" }}>
                    Já tem conta? <Link to="/login">Entrar</Link>
                </p>
            </Card>

            <SeloSystems />
        </div>
    );
};

export default RegistroEscritorio;
